import { MapsLight } from '@ha/icons';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import { Button, ButtonProps, Grid, IconButton, units } from '@ha/dsl';
import { useIntl } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';

import { getCityCanonical } from '../selectors';
import { toggleMobileMap } from '../actions';

const useStyles = makeStyles(theme => ({
  mapIcon: {
    height: '1rem',
    width: '1rem',
    marginRight: '0.5rem',
  },
  button: {
    height: units.rem(2.5),
    width: units.rem(2.5),
    border: '1px solid',
    borderRadius: '4px',
    padding: 0,
  },
  icon: {
    stroke: theme.palette.grey[500],
    height: units.rem(1.125),
    width: units.rem(1.125),
  },
}));

interface Props {
  color?: ButtonProps['color'];
  iconButton?: boolean;
}

const ToggleMobileMap: React.FC<Props> = ({
  color = 'primary',
  iconButton = false,
}) => {
  const { T } = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const cityCanonical = useSelector(getCityCanonical);

  const handleClick = React.useCallback(() => {
    dispatch(toggleMobileMap());
  }, []);

  return (
    <Track
      name="Clicked Map view button in Search"
      type="button"
      getDynamicData={() => ({
        cityCanonical,
      })}
    >
      {iconButton ? (
        <IconButton
          color="primary"
          onClick={handleClick}
          className={classes.button}
          data-test-locator="Mobile Map Button"
        >
          <MapsLight className={classes.icon} />
        </IconButton>
      ) : (
        <Button
          variant="outlined"
          color={color}
          size="small"
          onClick={handleClick}
          data-test-locator="Mobile Map Button"
        >
          <Grid container alignItems="center">
            <MapsLight className={classes.mapIcon} />
            {T('Map')}
          </Grid>
        </Button>
      )}
    </Track>
  );
};

export default ToggleMobileMap;
